import React from "react";
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import Home from "./components/Home/home";
import DataPage from "./components/DataPage/datapage";
import SgeLogin from "./components/auth/SgeLogin";
import ConopsLogin from "./components/auth/ConopsLogin";
import ProtectedRoutedata from "./components/auth/ProtectedRoutedata";
import { AuthProvider } from "./utils/AuthContext";
import AuthRoute from "./components/auth/AuthRoute";
import ConopsDataPage from "./CONOPS/conops-components/conops-datapage/conopsdatapage";
import ConopsHome from "./CONOPS/conops-components/conops-home/conopshome"

import NotFound from "./utils/NotFound";
import ErrorBoundary from "./utils/ErrorBoundary";

function App() {

  const router = createBrowserRouter([
    {
      path: "/login/sib",
      element: (
        <ErrorBoundary>
          <AuthRoute>
            <SgeLogin />
          </AuthRoute>
        </ErrorBoundary>
      ),
    },
    {
      path: "/login/conops",
      element: (
        <ErrorBoundary>
          <AuthRoute>
            <ConopsLogin />
          </AuthRoute>
        </ErrorBoundary>
      ),
    },
    {
      element: (
        <ErrorBoundary>
          <ProtectedRoutedata />
        </ErrorBoundary>
      ),
      children: [
        { path: "/", element: <Navigate to="/home" replace /> },
        { path: "/home", element: <ErrorBoundary><Home /></ErrorBoundary> },
        { path: "/smart-prospecting/data", element: <ErrorBoundary><DataPage /></ErrorBoundary> },
        { path: "/conops-data", element: <ErrorBoundary><ConopsDataPage /></ErrorBoundary> },
        { path: "/conops-home", element: <ErrorBoundary><ConopsHome /></ErrorBoundary> },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
